<template>
  <div class="log2">
    <div class="topBar">
      <div class="subTitle">
        <i
          class="far fa-window-minimize"
          style="transform:rotate(90deg);margin-right: -10px;color:rgba(52,152,219,1);"
        ></i>
        库存记录
        <div @click="getting()" class="rutun">
          <div>
            <i class="fas fa-sync-alt"></i>
          </div>
          <div style="margin-left:4px">刷新</div>
        </div>
      </div>
    </div>
    <div v-if="role" class="body">
      <div class="form-title">
        <div style="padding-left:10px">筛选查询</div>
      </div>
      <div style="background-color:white" class="search-box">
        <el-row class="search" :gutter="10">
          <el-col :span="2">
            <div class="label">客户名称:</div>
          </el-col>
          <el-col :span="4">
            <el-input v-model="to" clearable size="small" placeholder="客户名称"></el-input>
          </el-col>
          <el-col :span="2">
            <div class="label">商品名称:</div>
          </el-col>
          <el-col :span="4">
            <el-input v-model="name" clearable size="small" placeholder="商品名称"></el-input>
          </el-col>
          <el-col :span="1.5">
            <div class="label">货号:</div>
          </el-col>
          <el-col :span="4">
            <el-input v-model="item_no" clearable size="small" placeholder="商品货号"></el-input>
          </el-col>
          <el-col :span="4" align="center">
            <div class="search_button" @click="getting()">搜索</div>
          </el-col>
        </el-row>
      </div>
      <div style="background-color:white;margin-top:19px">
        <div class="table-top-border">
          <div class="table-top-title">
            <div class="table-top-left">
              <div>
                <i class="fas fa-bars"></i>
              </div>
              <div>数据列表</div>
            </div>
            <div style="margin-right:20px;display: flex;align-items: center;">
              <el-button @click="showPrintInfo">打印出库单</el-button>
            </div>
          </div>
        </div>
        <el-table :data="tableData" border style="width: 100%" @selection-change="printSelect">
          <!-- <el-table-column type="selection" width="30"></el-table-column> -->
          <el-table-column prop="id" label="编号" width="60"></el-table-column>
          <el-table-column prop="name" label="商品名称"></el-table-column>
          <el-table-column prop="item_no" label="商品货号"></el-table-column>
          <el-table-column prop="brand" label="品牌"></el-table-column>
          <el-table-column prop="to" label="用户"></el-table-column>
          <el-table-column prop="number" label="数量" width="50"></el-table-column>
          <el-table-column prop="send_time" label="日期"></el-table-column>
          <el-table-column prop="duty_code" label="发票号"></el-table-column>
          <el-table-column prop="create_member" label="操作者" width="80"></el-table-column>
          <el-table-column prop="remark" show-overflow-tooltip label="备注"></el-table-column>
          <el-table-column label="操作" align="center" width="100">
            <template slot-scope="scope">
              <el-link type="primary" @click="showDetail = true,getDetail(scope.$index)">查看</el-link>
            </template>
          </el-table-column>
        </el-table>
        <div class="pager">
          <el-row>
            <el-col :span="50">
              <el-pagination
                background
                layout="prev, pager, next"
                :total="total"
                :page-size="15"
                @current-change="setPage"
              >1</el-pagination>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <noAccess v-else></noAccess>
    <el-dialog title="出库详情" :visible.sync="showDetail" width="40%">
      <el-row type="flex" class="row-bg" align="bottom">
        <el-col :span="3" class="detail_title">
          <div class="grid-content bg-purple">商品名称:</div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple-light">{{detail.name}}</div>
        </el-col>
        <el-col :span="3" class="detail_title">
          <div class="grid-content bg-purple">商品货号:</div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">{{detail.item_no}}</div>
        </el-col>
      </el-row>
      <el-row type="flex" class="row-bg" align="bottom">
        <el-col :span="3" class="detail_title">
          <div class="grid-content bg-purple">商品品牌:</div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple-light">{{detail.brand}}</div>
        </el-col>
        <el-col :span="3" class="detail_title">
          <div class="grid-content bg-purple">商品规格:</div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">{{detail.specification}}</div>
        </el-col>
      </el-row>
      <el-row type="flex" class="row-bg" align="bottom">
        <el-col :span="3" class="detail_title">
          <div class="grid-content bg-purple">发货时间:</div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple-light">{{detail.send_time}}</div>
        </el-col>
        <el-col :span="3" class="detail_title">
          <div class="grid-content bg-purple">送货人:</div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">{{detail.send_member}}</div>
        </el-col>
      </el-row>
      <el-row type="flex" class="row-bg" align="bottom">
        <el-col :span="3" class="detail_title">
          <div class="grid-content bg-purple">发票号:</div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple-light">{{detail.duty_code}}</div>
        </el-col>
        <el-col :span="3" class="detail_title">
          <div class="grid-content bg-purple">客户:</div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">{{detail.to}}</div>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showDetail = false">取 消</el-button>
        <el-button type="primary" @click="showDetail = false">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="出库单打印" :visible.sync="showPrint" width="1200px">
      <el-dialog width="1200px" title="编辑出库单信息" :visible.sync="edit" append-to-body>
        <el-form :inline="true" class="demo-form-inline">
          <el-form-item label="购货单位:">
            <el-input v-model="showPrintData.purchase_com"></el-input>
          </el-form-item>
          <el-form-item label="发货日期:">
            <el-input v-model="showPrintData.send_time"></el-input>
          </el-form-item>
          <el-form-item>
            <el-input v-model="showPrintData.no"></el-input>
          </el-form-item>
        </el-form>
        <el-form :inline="true" class="demo-form-inline">
          <el-form-item label="联系人:">
            <el-input v-model="showPrintData.link_name"></el-input>
          </el-form-item>
          <el-form-item label="联系电话:">
            <el-input v-model="showPrintData.link_phone"></el-input>
          </el-form-item>
          <el-form-item label="收货地址:">
            <el-input v-model="showPrintData.address" style="width:300px"></el-input>
          </el-form-item>
        </el-form>
        <el-table :data="editPrintData" border style="width: 100%">
          <el-table-column prop="date" label="货号" width="180">
            <template slot-scope="scope">
              <el-input v-model="scope.row.item_no"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="商品名称" width="400">
            <template slot-scope="scope">
              <el-input v-model="scope.row.title"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="规格">
            <template slot-scope="scope">
              <el-input v-model="scope.row.specification"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="数量">
            <template slot-scope="scope">
              <el-input v-model="scope.row.number"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="单价">
            <template slot-scope="scope">
              <el-input v-model="scope.row.price"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="总价">
            <template slot-scope="scope">
              <el-input v-model="scope.row.total"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="备注">
            <template slot-scope="scope">
              <el-input v-model="printRemark[scope.$index]"></el-input>
            </template>
          </el-table-column>
        </el-table>
        <el-form style="margin-top:20px;" :inline="true" class="demo-form-inline">
          <el-form-item label="合计:">
            <el-input v-model="showPrintData.all_total"></el-input>
          </el-form-item>
        </el-form>
        <el-form :inline="true" class="demo-form-inline">
          <el-form-item label="发票号:">
            <el-input v-model="showPrintData.duty_code"></el-input>
          </el-form-item>
        </el-form>
        <el-form :inline="true" class="demo-form-inline">
          <el-form-item label="送货人:">
            <el-input v-model="showPrintData.send_member"></el-input>
          </el-form-item>
          <el-button type="primary" @click="confirmPrintData">确 定</el-button>
        </el-form>
      </el-dialog>
      <div class="header-name">
        <div style="font-size:30px;">业立生物科技(上海)股份有限公司出库单</div>
        <div style="margin-left:50px">联系电话:400-821-3401</div>
      </div>
      <div class="client-info">
        <div style="height:60px;width:120px">
          <img :src="this.serve+'/images/print_out.jpg'" alt />
        </div>
        <div style="margin-left:20px;">
          <div style="line-height: 2em;">
            <span>购货单位:</span>
            <span>{{showPrintData.purchase_com}}</span>
          </div>
          <div style="line-height: 2em;">
            <span>联系人:</span>
            <span>{{showPrintData.link_name}}</span>

            <span style="margin-left:20px">电话:</span>
            <span>{{showPrintData.link_phone}}</span>
          </div>
        </div>

        <div style="margin-left:180px;">
          <div style="line-height: 2em;">
            <span>发货日期:</span>
            <span>{{showPrintData.send_time}}</span>
            <span style="margin-left:20px;">{{showPrintData.no}}</span>
          </div>
          <div style="line-height: 2em;">
            <span>收货地址:</span>
            <span>{{showPrintData.address}}</span>
          </div>
        </div>
      </div>
      <div class="table-box">
        <table class="print-table" cellspacing="0" cellpadding="5">
          <tr>
            <th>货号</th>
            <th style="width:400px;">商品名称</th>
            <th style="width:80px;">规格</th>
            <th>数量</th>
            <th style="width:120px">单价</th>
            <th style="width:120px">总价</th>
            <th style="width:120px;">备注</th>
          </tr>
          <tr style="height:30px" v-for="(item,index) in productPrintData" :key="index">
            <td>{{item.item_no}}</td>
            <td >{{item.title}}</td>
            <td>{{item.specification}}</td>
            <td>{{item.number}}</td>
            <td>{{item.price}}</td>
            <td>{{item.total}}</td>
            <td>{{printRemark[index]}}</td>
          </tr>
          <tr style="height:30px">
            <td>小计:</td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td>{{showPrintData.all_total}}</td>
            <td></td>
          </tr>
          <tr style="height:50px">
            <td>开票情况:</td>
            <td>
              <span>已开票</span>
               <span style="margin-left:100px">未开票</span>
            </td>
            <td>发票号码:</td>
            <td colspan="4">{{showPrintData.duty_code}}</td>
          </tr>
        </table>
        <div style="line-height:1.5em">
          说明: 请收货人在收到货物及发票时请认真验收核对，确定是否与订货产品一致。如有货物短缺及损坏，请于三日内与我公司物流部联系，逾期当做
          已确认正常收货。若有质量问题，请于收货当日起三周内与我公司技术不联系，逾期则视为以上产品无质量问题，谢谢合作！
          <div>
            <span>销货单位： 业立生物科技（上海）股份有限公司</span>
            <span style="margin-left:40px">地址：上海市肇嘉浜路789号均瑶国际广场17楼E3座</span>
            <span style="margin-left:40px">电话：021-64179406</span>
          </div>
          <div style="line-height:2em">
            <span>送货人：{{showPrintData.send_member}}</span>
            <span style="margin-left:500px">收票及收货人：</span>
          </div>
        </div>
      </div>
      <div class="print-button">
        <el-button type="primary" @click="printOpenOrder">打 印</el-button>
        <el-button @click="edit = !edit" type="warning">编 辑</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'inventoryList',
  data() {
    return { serve: this.$store.state.serve,
    role:true,
      username: this.$cookies.get('username'),
      token: this.$cookies.get('token'),
      serve: this.$store.state.serve,
      id: this.$route.params.id,
      formLabelWidth: '100px',
      tableData: [],
      to: null,
      time: '',
      resType: 0,
      type: null,
      total: 0,
      page: 1,
      showDetail: false,
      detail: {},
      name: '',
      item_no: '',
      showPrint: false,
      printData: [],
      showPrintData: [],
      productPrintData: [],
      edit: false,
      editPrintData: [],
      printRemark:[]
    }
  },
  created() {
    this.$store.state.topActiveId = 8
    this.$store.state.leftTitle = '出库记录'
    this.getting()
  },
  methods: {
    alert_success(message) {
      this.$message({
        type: 'success',
        message: message,
        offset: 200
      })
    },
    alert_error(message) {
      this.$message({
        type: 'error',
        message: message,
        offset: 200
      })
    },
    printOpenOrder(){
      var qs = require('qs')
      var printInfo = this.showPrintData
      delete(printInfo.results);
      for (let index = 0; index < this.productPrintData.length; index++) {
            this.productPrintData[index].remark = ''
      }
      var product =  JSON.stringify(this.productPrintData);
      this.printRemark = []
      window.open(this.serve + '/admin/printer/outWares?product=' + product + '&info='+JSON.stringify(printInfo)  );
    },
    confirmPrintData(){
      this.edit = !this.edit
      for(let i in this.editPrintData){
        this.productPrintData[i] = this.editPrintData[i]
        this.productPrintData[i].remark = this.printRemark[i]
      }
    },
    showPrintInfo() {
      var qs = require('qs')
      if (this.printData.length == 0) {
        this.alert_error('请选择想要打印的出库信息')
        return
      }
      var formData = []
      var printData = this.printData
      var orderCode = printData[0].orderCode
      for (let i in printData) {
        if (printData[i].orderCode != orderCode) {
          formData['orderCode'] = ''
        } else {
          formData['orderCode'] = orderCode
        }
        var data = {}
        data.item_no = printData[i].item_no
        data.title = printData[i].name
        data.specification = printData[i].specification
        data.number = printData[i].number
        data.duty_code = printData[i].duty_code
        data.send_member = printData[i].send_member
        formData[i] = data
      }
      formData.username = this.username
      formData.token = this.token
      this.axios
        .post(this.serve + '/admin/print_out_list', qs.stringify(formData))
        .then(res => {
          var data = res.data
          if (data.status == 'success') {
            this.showPrintData = data.data
            var data2 = data.data.results.concat()
            this.productPrintData = data.data.results
            this.editPrintData = data2
            if (this.productPrintData.length < 5) {
              var item = {
                item_no: '',
                title: '',
                price: '',
                total: '',
                specification: '',
                number:'',
                remark:''
              }
              for (let index = 0; index < 5; index++) {
                if (index > this.productPrintData.length - 1) {
                  this.productPrintData[index] = item
                }
              }
            }
          }
        })

      this.showPrint = !this.showPrint
    },
    printSelect(val) {
      console.log(val)
      this.printData = val
    },
    getDetail(index) {
      this.detail = this.tableData[index]
    },
    setType(e) {
      if (e == 1) {
        this.type = 0
      } else if (e == 2) {
        this.type = 1
      } else {
        this.type = null
      }
      this.resType = e
      this.getting()
    },
    filterTag(value, row) {
      return row.tag === value
    },
    setPage(v) {
      this.page = v
      this.getting(v)
    },
    getting(page) {
      const loading = this.$loading({
        lock: true,
        text: '正在加载...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      var where = {}
      where.username = this.username
      where.token = this.token
      where.type = 1
      where.page = page
      where.to = this.to
      where.name = this.name
      where.item_no = this.item_no
      this.axios
        .get(this.serve + '/admin/log_inventory2', {
          params: where
        })
        .then(res => {
          var data = res.data
          if (data.status == 'success') {
            var res = data.data.results
            this.total = data.data.total
            this.page = data.data.page
            for (let i in res) {
              var timeNew = new Date(parseInt(res[i].create_date) * 1000)
                .toLocaleString()
                .replace(/:\d{1,2}$/, ' ')
              res[i].create_date = timeNew
            }
            this.tableData = data.data.results
          } else {
            if(data.msg == "无权访问"){
              this.role = false
            }
            this.tableData = []
          }
          loading.close()
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.log2 {
  .out-box {

    border: 1px black solid;
    padding-left: 10px;
    padding-right: 10px;
    padding-top: 30px;
    padding-bottom: 30px;
  }

  .header-name {
    display: flex;
    justify-content: center;
    align-items: flex-end;
  }
  .client-info {
    font-size: 16px;
    display: flex;
    justify-content: left;
  }
  .table-box {
    margin-top: 20px;
  }
  .print-table {
    font-size: 16px;
    width: 100%;
    border-collapse: collapse;
    th {
      border: black 1px solid;
    }
    td {
      border: black 1px solid;
      text-align: center;
    }
  }
  .print-button {
    margin-top: 10px;
    display: flex;
    justify-content: flex-end;
  }
  .search-box {
    width: 1054px;
    height: 86px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(221, 221, 221, 1);
  }
  color: #333;
  min-height: 1000px;
  padding-bottom: 100px;
  background: #f5f5f5;
  .row-bg {
    margin-bottom: 20px;
  }
  .detail_title {
    font-size: 17px;
    font-weight: 600;
  }
  .pager {
    display: flex;
    justify-content: center;
  }
  .addSupplier {
    margin-right: 20px;
  }
  .addSupplier:hover {
    color: white;
    background-color: #0099ff;
  }
  .label {
    text-align: right;
    padding-right: 10px;
    font-size: 14px;
  }
  .search .el-col {
    line-height: 80px;
  }
  .search_button {
    text-align: center;
    line-height: 28px;
    font-size: 14px;
    font-family: 'MicrosoftYaHeiLight';
    font-weight: 300;
    color: rgba(102, 102, 102, 1);
    width: 74px;
    height: 28px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(221, 221, 221, 1);
    position: absolute;
    right: 18px;
    top: 29px;
    cursor: pointer;
  }
  .search_button:hover {
    background-color: #0099ff;
    color: #fff;
  }
  .menu1 {
    display: flex;
    margin-bottom: 20px;
    .btn3 {
      margin-right: 0;
      i {
        font-style: normal;
        color: #f64e62;
      }
    }
    .btn3:hover i {
      color: #fff;
    }
    .active i {
      color: #fff;
    }
  }
  .topBar {
    margin-bottom: 40px;
  }
  .subTitle {
    width: 1056px;
    margin: 0 auto;
    font-size: 14px;
    position: relative;
    .rutun {
      width: 78px;
      height: 28px;
      background: #fff;
      border: 1px solid rgba(221, 221, 221, 1);
      text-align: center;
      margin-top: 9px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      right: 0;
      top: 0;
      cursor: pointer;
    }
    .rutun:hover {
      color: #0099ff;
    }
  }
  .form-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .body {
    width: 1056px;
    margin: 0 auto;
    .table-top-title {
      background-color: #eee;
      width: 100%;
      height: 46px;
      display: flex;
      justify-content: space-between;
    }
    .table-top-left {
      display: flex;
      align-items: center;
      > div {
        margin-left: 10px;
      }
    }
    .table-top-border {
      border: 1px solid rgba(221, 221, 221, 1);
    }
    .search {
      display: flex;
      justify-content: left;
      .el-col {
        line-height: 80px;
      }
    }
  }
}
</style>